// export const config = {
//     network: 'testnet',   
//     endpoints: ['https://devnet.evercloud.dev/d194af39b9d24ef89707c161b679eabf/graphql'],
//     fileDeployer: '0:39ae5d31702c3a088d5fdadfcfd2426664278f238552491df893ae552120b0c4',
//     utils: '0:8b7ea04202cf25ce09327d3dfa214e42209e1b9e27335d26c224271092ae1ee2',
// }

export const config = {
    network: 'mainnet',   
    endpoints: ['https://mainnet.evercloud.dev/d194af39b9d24ef89707c161b679eabf/graphql'],
    fileDeployer: '0:a34d40801cca179bf3fc311ffd1fb1b8c4cb02eed50c218a07a1486e201e6461',
    utils: '0:838f9486ae2568600c5cc003116c05e1c391cbcf64b665bfec114b3beba66790',
}